











































































































































































































import { getInitiativePDF, getValidationIniziative, updateValidationIniziative } from "@/services";
import {
  IniziativeStatusType,
  SurveyActionType,
  SurveyStatusResult,
  SurveyStatusType,
  SurveyType,
  ValidationIniziativeMatrix,
  ValidationIniziativeMatrixElement,
} from "@/interfaces";
import { Component, Vue } from "vue-property-decorator";

import { notifyError, notifySuccess } from "@/common/notify";

import { date } from "quasar";
import { AppModule, AuthModule } from "@/store";
import CreateProjectDialog from "@/components/CreateProjectDialog.vue";

@Component
export default class ValidationIniziative extends Vue {
  @AuthModule.bindings.Getter
  isAdministrator!: boolean;

  @AuthModule.bindings.State
  status!: SurveyStatusResult;

  @AppModule.bindings.State
  validatedInitiativeAccordion!: number;

  loading = false;
  downloading = false;
  downloadingElement = -1;
  elements: ValidationIniziativeMatrix[] = [];

  openedItem = 0;
  currentAccordion = 0;

  clonedElement: ValidationIniziativeMatrixElement | any = {};

  searchText = "";
  planningYear: number | null = null;

  statusOptions = [
    {
      label: "Validata",
      value: "public",
    },
    {
      label: "Da valutare",
      value: "waiting_approval",
    },
  ];

  mounted() {
    const planningYears = [...this.status.planning_years];
    const planningYear = planningYears.pop();

    if (planningYear) {
      this.planningYear = planningYear;
    }

    this.loadMatrix();
  }

  async loadMatrix() {
    try {
      this.loading = true;
      this.elements = await getValidationIniziative(this.planningYear === null ? 2022 : this.planningYear);
      // this.elements

      if (this.validatedInitiativeAccordion != null) {
        this.openedItem = this.validatedInitiativeAccordion;
        this.currentAccordion = this.validatedInitiativeAccordion;
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.loading = false;
    }
  }

  openShowElementRef(element: ValidationIniziativeMatrixElement) {
    let type = SurveyType.INITIATIVE_VALIDATED;
    if (element.surveys.length > 0) {
      const survey = element.surveys[0];

      switch (survey.section_name) {
        case "iniziativa_attrattivita":
          type = SurveyType.INITIATIVE_ATTRACTION;
          break;
        case "iniziativa_accessibilita":
          type = SurveyType.INITIATIVE_ACCESSIBILITY;
          break;
        case "iniziativa_accoglienza":
          type = SurveyType.INITIATIVE_HOSPITALITY;
          break;
        case "iniziativa_affermazione_brand":
          type = SurveyType.INITIATIVE_AWARENESS;
          break;
        case "iniziativa_visibilita_offerta":
          type = SurveyType.INITIATIVE_VISIBILITY;
          break;
      }
    }

    this.$router
      .push(`survey/${type}/${element.surveys.length > 0 ? element.surveys[0].id : element.id}`)
      .catch(error => console.log(error));
  }

  openShowElement(element: ValidationIniziativeMatrixElement) {
    const type = SurveyType.INITIATIVE_VALIDATED;

    if (this.isAdministrator && element.surveys.length === 1) {
      return;
    }

    this.$router
      .push(
        `survey/${type}/${element.surveys.length > 1 ? element.surveys[1].id : element.id}/${
          element.surveys.length > 1 ? SurveyActionType.UPDATE : SurveyActionType.NEW
        }`,
      )
      .catch(error => console.log(error));
  }

  cloneRow(element: ValidationIniziativeMatrixElement) {
    this.clonedElement = { ...element };
  }

  stickOpenItem(i: number) {
    this.$store.commit("app/setValidatedInitiativeAccordion", i);
  }

  createProject(items: ValidationIniziativeMatrixElement[]) {
    let initiative: unknown[] = [];

    console.log(items);

    items.forEach(item => {
      if (item.status === IniziativeStatusType.PUBLIC) {
        const initiativeFilt = [...item.surveys].find(el => el.id === item.main_survey_id);

        if (initiativeFilt) {
          initiative = [
            ...initiative,
            {
              label: item.name,
              value: initiativeFilt.id,
            },
          ];
        }
      }
    });

    this.$q.dialog({
      component: CreateProjectDialog,
      initiative,
      parent: this,
    });
  }

  async onUpdateElement(
    oldElement: ValidationIniziativeMatrixElement,
    key: string,
    element: ValidationIniziativeMatrixElement,
  ) {
    if (oldElement.status !== element.status) {
      try {
        await updateValidationIniziative(element.id, { status: element.status });
        oldElement.status = element.status;
        notifySuccess("Iniziativa aggiornata con successo!");
      } catch (error) {
        console.log(error);
        notifyError("Errore imprevisto, non è stato possibile aggiornare l'iniziativa!");
      }
    }
  }

  getElementDate(element: ValidationIniziativeMatrixElement) {
    if (element.surveys.length > 0) {
      return date.formatDate(element.surveys[1].updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  getElementRefDate(element: ValidationIniziativeMatrixElement) {
    if (element.surveys.length > 0) {
      return date.formatDate(element.surveys[0].updated_at, "DD/MM/YYYY HH:mm");
    }

    return "";
  }

  async downloadPdf(element: ValidationIniziativeMatrixElement) {
    try {
      this.downloading = true;
      this.downloadingElement = element.id;
      const response = await getInitiativePDF(element.surveys[0].id);
      const blob = new Blob([response.data], { type: response.data.type });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(blob);
      link.download = element.name;
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      console.error(error);
    } finally {
      this.downloading = false;
      this.downloadingElement = -1;
    }
  }

  get columns() {
    const cols: any = [
      {
        name: "name",
        label: "Nome Iniziativa",
        field: "name",
        align: "left",
        sortable: true,
      },
      {
        name: "status",
        label: "Stato",
        field: (row: ValidationIniziativeMatrixElement) => this.statusSurveyLabel(row),
        align: "left",
        sortable: true,
      },
      { label: "Dettagli iniziativa", name: "edit-ref", align: "center" },
      { label: "Ultima modifica", name: "date-ref", align: "left" },
      { label: "Stato iniziativa", name: "edit", align: "center" },
      { label: "Ultimo aggiornamento", name: "date", align: "left" },
      { label: "", name: "download", align: "center" },
    ];

    if (this.isAdministrator) {
      cols.unshift({
        name: "cat",
        label: "Cat.",
        field: "cat",
        align: "left",
      });
    }

    return cols;
  }

  get statusSurveyRefLabelClass() {
    return (element: ValidationIniziativeMatrixElement) => {
      const status = element.surveys[0].status;
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "text-positive";
        case SurveyStatusType.TO_BE_UPDATED:
          return "text-warning";
        case SurveyStatusType.IN_PROGRESS:
          return "text-negative";
        default:
          return "text-negative";
      }
    };
  }

  get statusSurveyRefLabel() {
    return (element: ValidationIniziativeMatrixElement) => {
      const status = element.surveys[0].status;
      switch (status) {
        case SurveyStatusType.COMPLETED:
          return "Visualizza"; // era "Compilato"
        case SurveyStatusType.TO_BE_UPDATED:
          return "Da Aggiornare";
        case SurveyStatusType.IN_PROGRESS:
          return "Da Completare";
        default:
          return "Da Completare";
      }
    };
  }

  get statusSurveyLabelClass() {
    return (element: ValidationIniziativeMatrixElement) => {
      if (element.surveys.length > 1) {
        const status = element.surveys[1].status;
        switch (status) {
          case SurveyStatusType.COMPLETED:
            return "text-positive";
          case SurveyStatusType.TO_BE_UPDATED:
            return "text-warning";
          case SurveyStatusType.IN_PROGRESS:
            return "text-negative";
          default:
            return "text-negative";
        }
      }

      return "text-negative";
    };
  }

  get statusSurveyLabel() {
    return (element: ValidationIniziativeMatrixElement) => {
      if (element.surveys.length > 1) {
        const status = element.surveys[1].status;

        if (element.surveys[1].label) {
          return element.surveys[1].label;
        }

        switch (status) {
          case SurveyStatusType.COMPLETED:
            return "Compilato";
          case SurveyStatusType.TO_BE_UPDATED:
            return "Da Aggiornare";
          case SurveyStatusType.IN_PROGRESS:
            return "Da Completare";
          default:
            return "Da Completare";
        }
      }

      return "Da Completare";
    };
  }

  get statusLabelClass() {
    return (status: IniziativeStatusType) => {
      switch (status) {
        case IniziativeStatusType.PUBLIC:
          return "text-positive";
        case IniziativeStatusType.IN_PROGRESS:
          return "text-warning";
        default:
          return "";
      }
    };
  }

  get statusLabel() {
    return (status: IniziativeStatusType) => {
      switch (status) {
        case IniziativeStatusType.PUBLIC:
          return "Validata";
        case IniziativeStatusType.IN_PROGRESS:
          return "Da valutare";
        default:
          return "Indefinito";
      }
    };
  }

  get filteredElements() {
    return this.elements.filter(element => element.title.toLowerCase().includes(this.searchText.toLowerCase()));
  }
}
